import { useCallback, useMemo } from 'react'
import { Database } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchDataCollection, LEGAL_STATUS_OPTS, LEGAL_STR as S, type LegalRow } from './legalFlowApi'

/**
 * A19.09 — Ma'lumot to'plash (data collection, read-only). Ma'lumot so'rovini
 * bajarish uchun to'plash bosqichi (kind=data). GET /admin/legal ustidan.
 * Backend yo'q/xato → fail-soft.
 */
export function LegalDataCollectionScreen() {
  const columns = useMemo<AdminColumn<LegalRow>[]>(
    () => [
      { key: 'id', header: S.id, type: 'id', width: 70 },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
      { key: 'authority', header: S.authority, type: 'text', minWidth: 180 },
      { key: 'reference', header: S.reference, type: 'text', width: 150 },
      {
        key: 'affected_user_id',
        header: S.affected,
        type: 'text',
        width: 150,
        sortable: false,
        render: (r) => (r.affected_user_id ? (r.username ? `@${r.username}` : `#${r.affected_user_id}`) : '—'),
      },
      { key: 'status', header: S.status, type: 'enum', width: 130, options: LEGAL_STATUS_OPTS },
    ],
    [],
  )
  const fetcher = useCallback(fetchDataCollection, [])
  return (
    <>
      <PageHeader title={S.collectionTitle} screenId="A19.09" description={S.collectionDesc} />
      <DataTable<LegalRow>
        screenId="A19.09"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Database size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
